import {Picture} from '@core/services/picture';

export type LineupArray = Array<Array<LineupPlayer>>;
export type SimpleLineupArray = Array<LineupPlayer>;
export type ReserveArray = Array<LineupPlayer>;

export class Lineup {
  team: string;
  formation: number;

  lineupWithoutFormation: SimpleLineupArray;

  lineup: LineupArray;
  reserve: ReserveArray;

  public constructor(init?: Partial<Lineup>) {
    Object.assign(this, init);

    this.lineup = [];
    this.lineupWithoutFormation = [];
    if (init.lineup && init.lineup instanceof Array) {
      if (init.formation !== -1) {
        init.lineup.forEach(lineUpEntry => {
          if (lineUpEntry instanceof Array) {
            const playerInLineUpArray = [];
            lineUpEntry.forEach(playerEntry => {
              const player = new LineupPlayer(playerEntry as any);
              this.lineupWithoutFormation.push(player);
              playerInLineUpArray.push(player);
            });
            this.lineup.push(playerInLineUpArray);
          }
        });
      } else {
        init.lineup.forEach(playerOfLineup => {
          const player = new LineupPlayer(playerOfLineup as any);
          this.lineupWithoutFormation.push(player);
        });
      }
    }

    this.reserve = [];
    init.reserve.forEach(reserveEntry => {
      const player = new LineupPlayer(reserveEntry);
      this.reserve.push(player);
    });
  }

  hasFormation(): boolean {
    return !(this.formation === -1);
  }

  hasNoFormationButPlayers(): boolean {
    return this.hasFormation() === false && this.lineupWithoutFormation.length > 0;
  }

  getAllLineupPlayers(): LineupPlayer[] {
    return this.lineupWithoutFormation;
  }

  getLineUpPlayerIDs(): string[] {
    const playerIDs = [];
    this.getAllLineupPlayers().forEach(playerInLineUp => {
      playerIDs.push(playerInLineUp.playerid);
    });
    return playerIDs;
  }

  getAllReservePlayers(): LineupPlayer[] {
    const players = [];
    this.reserve.forEach(player => {
      players.push(player);
    });
    return players;
  }

  getReservePlayerIDs(): string[] {
    const playerIDs = [];
    this.getAllReservePlayers().forEach(playerInReserve => {
      playerIDs.push(playerInReserve.playerid);
    });
    return playerIDs;
  }
}

export class LineupPlayer {
  playerid: string;
  playername: string;
  firstname: string;
  lastname: string;
  position: string;
  number: number;
  status: number;
  captain: boolean;
  pictures: Picture[];

  public constructor(init?: Partial<LineupPlayer>) {
    this.pictures = [];
    // copy JSON, else it's doubled
    let picturesJson = [];
    if (init.pictures) {
      picturesJson = JSON.parse(JSON.stringify(init.pictures));
    }
    init.pictures = [];

    Object.assign(this, init);

    picturesJson.forEach(pictureJson => {
      const picture = new Picture(pictureJson);
      this.pictures.push(picture);
    });
  }

  public getNumberOrInitials(): string {
    if (this.number != null) {
      return this.number.toString();
    }

    let firstNameLetter = '';
    let lastNameLetter = '';

    if (this.firstname != null && this.firstname.length > 0) {
      firstNameLetter = this.firstname[0];
    }
    if (this.lastname != null && this.lastname.length > 0) {
      lastNameLetter = this.lastname[0];
    }

    return firstNameLetter + lastNameLetter;
  }

  public getNumberOrMinus(): string {
    if (this.number != null) {
      return this.number.toString();
    }

    return '-';
  }

  public getName(fullFirstName: boolean = true): string {
    let name = '';

    if (this.firstname) {
      if (fullFirstName) {
        name = this.firstname;
      } else if (this.firstname && this.firstname.length > 0) {
        name = this.firstname.charAt(0) + '.';
      }
    }
    if (this.lastname) {
      if (name.length > 0) {
        name = name + ' ' + this.lastname;
      } else {
        name = this.lastname;
      }
    }

    return name;
  }

  public getFaceImage(size: string): string {
    return Picture.getImageOfSizeByString(this.pictures, size, 'face', null);
  }
}
